<template>
  <div>
    <table
      class="table-comment text-center"
    >
      <tr
        class="grey-td"
      >
        <td>倉庫</td>
        <td>時效</td>
        <td>首重</td>
        <td>續重</td>
      </tr>
      <tr
        v-for="(feeItem,i) in feeList"
        :key="feeItem.srid"
        class="card-bg"
      >
        <td nowrap>
          {{ feeItem.label }}
        </td>
        <td nowrap>
          {{ feeItem.timespanMin }}-{{ feeItem.timespanMax }}天
        </td>
        <td>
          NT$ {{ feeItem.fwFee }} / KG
        </td>
        <td nowrap>
          <template v-if="viewAirFeeType==='frt'">
            NT$ {{ $calc.add(feeItem.awFee, feeItem.frtFee) }} / KG
          </template>
          <template v-else-if="viewAirFeeType==='tax'">
            NT$ {{ $calc.add(feeItem.awFee, feeItem.taxFee) }} / KG
          </template>
          <template v-else>
            NT$ {{ feeItem.awFee }} / KG
          </template>
        </td>
      </tr>
      <tr class="card-bg">
        <td colspan="4">
          <template v-if="$store.state.userData.settings && $store.state.edition=== 's'">
            普/特貨同價 不包稅
          </template>
          <template v-else>
            普/特貨同價 全包稅
          </template>
        </td>
      </tr>
    </table>
    <table
      style="margin-top: -1px;"
      class="table-comment contentTable"
    >
      <template v-if="$store.state.userData.settings && $store.state.edition=== 's'">
        <tr>
          <td>
            <div class="subTitle text-left">
              正式報關
            </div>
          </td>
          <td>
            <div>
              快件專區報關費 210元 一般倉報關費 1800元
            </div>
          </td>
        </tr>
      </template>
      <tr>
        <td>
          <div class="subTitle text-left">
            體積重量
          </div>
        </td>
        <td>
          <div>
            空運包裹長x寬x高/6000=體積重量<br>
            體積重量與實際重量取較大的重量計重<br>
            體積重量大於實際重量3倍以內全部優惠（即按實際重量計重）<br>
            體積重量大於實際重量3倍以上享有50%優惠（即按體積重量/2計重）
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            計重方式
          </div>
        </td>
        <td>
          <div>
            打包前稱重不計包材重量。超出0.1KG內不計重量，超過以1KG進位。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            丟貨賠償
          </div>
        </td>
        <td>
          按丟失保價金額賠償
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            禁運品
          </div>
        </td>
        <td>
          <div>
            酒、毒品、槍支、水果、植物、電話卡(網卡)、易燃易爆物、電動車類(平衡車、滑板車)、電子煙相關產品...
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    inject: Boolean,
  },
  computed: {
    viewAirFeeType: {
      get () {
        return this.$store.state.shippingRate.viewAirFeeType
      },
      set (v) {
        this.$store.commit('shippingRate/setViewAirFeeType', v)
      }
    },
    feeList () {
      const list = this.$store.state.jyShippingRatesSource.filter(item => item.transport === 'air' && item.type === 'twp')
      list.sort((a, b) => {
        if (a.addrid === '2769') {
          return -1
        }
        return 0
      })
      return list.filter(whs => {
        if (whs.addrid === '1769' || whs.addrid === '1050') {
          return false
        }
        return true
      }).map(whs => {
        const fee = {
          ...whs,
        }
        if (fee.srExtras && fee.srExtras.billboard) {
          Object.assign(fee, fee.srExtras.billboard)
        }

        return fee
      })
    },
  },
}
</script>
<style lang="postcss" scoped>
.grey-td {
  background: #efefef;
}
.dark {
  .grey-td {
    background: #353535;
  }
}
.feeTypeBtn {
  cursor: pointer;
}
.feeTypeIcon {
  font-size: 18px !important;
  margin-bottom: 1px;
  &.active{
    color: #F2B500;
  }
}
.table-comment {
  width: 100%;
  td {
    padding: 10px;
  }
}
.contentTable {
  tr:first-child td {
    border-top: 0;
  }
  td:first-child {
    width: 100px;
    border-right: 0;
  }
  td:nth-child(2){
    border-left: 0;
  }
  .subTitle:before {
    background: #F2B500;
  }
}
</style>
